import { html } from 'lit';
import { registerMemberWorkspaceModule } from '../../pages/app-members/workspace/member-workspace-modules.js';

// Auto-register the Glass.DataEntry domain module when this file is imported.
// This module will appear in the member workspace for groups with the Glass.DataEntry domain.
// It allows system tenant admins to manage which glass processor sites the group can access
// for data entry purposes.

registerMemberWorkspaceModule({
  id: 'domain-glass-dataentry',
  label: 'Glass',
  icon: 'gear',
  order: 51, // After glass-processor (50)
  section: 'Configuration',
  domains: ['Glass.DataEntry'], // Only visible to groups with this domain
  async load() {
    // Lazy-load the main component
    await import('./glass-dataentry-workspace.js');
  },
  render: (context) => {
    return html`
      <glass-dataentry-workspace
        .group=${context.group}
        .imis=${context.imis}
        .domains=${context.domains}
      ></glass-dataentry-workspace>
    `;
  },
});
